import script from "./historyGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./historyGroup.vue?vue&type=script&setup=true&lang=js"

import "./historyGroup.vue?vue&type=style&index=0&id=4031e740&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4031e740"]])

export default __exports__